var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{staticClass:"gdc-background-color",attrs:{"height":"50px"}},[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{staticStyle:{"margin-left":"-20px"},attrs:{"span":5}},[_c('img',{attrs:{"src":require("./images/GDC_lgo_1.png"),"width":"71.5","height":"50","alt":"Logo"}})])],1)],1),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-567fa648","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContainHeaderLayout/ContainHeaderLayout.vue
// module id = null
// module chunks = 